
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { TweenMax, TimelineMax, Power2 } from 'gsap';

@Component
export default class BmnOrientationModal extends Vue {
  private bmnTurner = new TimelineMax({repeat: -1});
  public mounted() {
    this.bmnTurner.to(this.$refs.arrow, 1.5, {rotation: -360, transformOrigin: '54% 49.5%', ease: Power2.easeOut});
  }
}
